import { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { COOKIES } from '../../constants/cookies';
import mixpanelConfig from '../../constants/mixpanelConfig';
import segmentConfig from '../../constants/segmentConfig';
import useAnalytics from '../useAnalytics';
import {
  TradeState,
  TradeStateNew,
  TradeStateNewName
} from '../../types/trade';
import { getCookie } from '../../utils/cookies';

const useSearchTracking = (
  isSearchFromRecentSearches: boolean,
  searchIn: string,
  searchResults: any,
  searchResultFetched: boolean,
  searchString: string,
  tradeState: any,
  setIsSearchFromRecentSearches: (boolean) => void,
  setSearchResultFetched: (boolean) => void
) => {
  const track = useAnalytics();
  const [context, tradeStateContext] = useSelector(
    state => [
      state?.ui?.nav?.primary?.context,
      state?.ui?.nav?.secondary?.context
    ],
    shallowEqual
  );
  useEffect(() => {
    function trackSearchQuery() {
      const returnUrl = getCookie(COOKIES.GO_BACK_FROM_SEARCH);

      track(mixpanelConfig.names.searchTrade, {
        search_keyword: searchString,
        search_from_history: isSearchFromRecentSearches,
        section: context === 1 ? 'buy' : 'sell',
        trade_state: tradeStateContext ? TradeState[tradeStateContext] : null,
        source:
          returnUrl?.includes('trade') && !returnUrl?.includes('list')
            ? 'VDP'
            : 'List view',
        searching_for: searchIn,
        search_filtered_state:
          tradeState !== TradeStateNew.ALL
            ? TradeStateNewName[tradeState]
            : TradeStateNew.ALL,
        search_result_found: searchResults?.length > 0
      });
    }

    if (searchResultFetched && searchResults?.length) {
      track(segmentConfig.names.loadListOfTrades, {
        // required properties, but not relevant for Pending list
        list_sort_option_value: 'N/A',
        sc_sale_event_view_type: null,
        vehicle_cards_view_type: null
      });
    }

    if (searchResultFetched && searchString) {
      trackSearchQuery();
      setIsSearchFromRecentSearches(false);
      setSearchResultFetched(false);
    }
  }, [
    context,
    isSearchFromRecentSearches,
    track,
    searchIn,
    searchResultFetched,
    searchResults?.length,
    searchString,
    setIsSearchFromRecentSearches,
    setSearchResultFetched,
    tradeState,
    tradeStateContext
  ]);
};

export default useSearchTracking;
